import { createContext, useContext, useEffect, useState } from "react";
import { cadastrarEmpresa } from "../services/EmpresaService";
import { loginUsuario, cadastrarUsuario, usuarioExistente } from "../services/UserService";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    const salvo = localStorage.getItem("usuario");
    if (salvo) setUsuario(JSON.parse(salvo));
    setCarregando(false);
  }, []);

  async function login({ identificador, senha }) {
    const res = await loginUsuario(identificador, senha);  
    const user = res.data;

    if (!user) throw new Error("Usuário não encontrado");

    localStorage.setItem("usuario", JSON.stringify(user));
    setUsuario(user);
    return user;
  }

  async function signup(dados) {
    const res = await cadastrarUsuario(dados);
    const user = res.data;
    localStorage.setItem("usuario", JSON.stringify(user));
    setUsuario(user);
    return user;
  }

  function logout() {
    localStorage.removeItem("usuario");
    setUsuario(null);
  }
  
  async function signupCompany(dados) {
    const res = await cadastrarEmpresa(dados);
    const empresa = res.data;
    localStorage.setItem("empresa", JSON.stringify(empresa));
    setUsuario(empresa);
    return empresa;
  }

  async function userExists(identificador) {
    const res = await usuarioExistente(identificador);  
    const user = res.data;
    return user;
  }

  return (
    <AuthContext.Provider value={{ usuario, carregando, login, signup, logout, signupCompany, userExists }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
